import ToggleWeightCost from "@/components/toggleWeightCost/toggleWeightCost.vue";
// extending Doughnut allows calling this.renderChart :)
import { Doughnut } from "vue-chartjs";
import { circleChartOptions } from "@/services/chartCustomTooltips";
import { REQUEST_STATE } from "@/enums";
import { createNamespacedHelpers } from "vuex";

const { mapGetters: userGetters } = createNamespacedHelpers("user"),
	{ mapGetters: filtersGetters } = createNamespacedHelpers("filters"),
	{ mapGetters: brandingGetters } = createNamespacedHelpers("branding");

export default {
	extends: Doughnut,
	components: { ToggleWeightCost },

	props: {
		wasteSourceServiceTimes: { type: Object },

		state: {
			type: String,
			validator(requestState) {
				return Object.keys(REQUEST_STATE).includes(requestState);
			},
		},
	},

	watch: {
		wasteSourceServiceTimes() {
			this.render();
		},

		isCostToggleActive() {
			this.render();
		},
	},

	data() {
		return {
			isCostToggleActive: false,
			REQUEST_STATE,

			chartData: {
				labels: [],
				datasets: [
					{
						backgroundColor: [],
						data: [],
					},
				],
			},

			tooltipContent: [
				{
					text: "tooltips_content.source_of_waste.title",
					type: "headline",
				},
				{
					text: "tooltips_content.source_of_waste.content",
					type: "text",
				},
				{
					text: "tooltips_content.source_of_waste.dash1",
					type: "text",
				},
				{
					text: "tooltips_content.source_of_waste.dash2",
					type: "text",
				},
				{
					text: "tooltips_content.source_of_waste.dash3",
					type: "text",
				},
				{
					text: "tooltips_content.source_of_waste.dash4",
					type: "text",
				},
			],
		};
	},

	computed: {
		...userGetters(["activeOutlet", "weightUnit", "serviceTimeSets"]),

		...filtersGetters(["activeWasteType"]),

		...brandingGetters(["sourceWasteColors"]),

		sortedWasteSource() {
			let bySource = {
				production: {
					source: "production",
					weight: 0,
					cost: 0,
				},
				preparation: {
					source: "preparation",
					weight: 0,
					cost: 0,
				},
				plate: {
					source: "plate",
					weight: 0,
					cost: 0,
				},
			};

			Object.keys(bySource).forEach((source) => {
				bySource[source].__color = this.sourceWasteColors[source];
			});

			Object.keys(this.wasteSourceServiceTimes).forEach((id) => {
				["stx", ...this.serviceTimeSets[id].st_labels].forEach((label) => {
					Object.keys(bySource).forEach((source) => {
						const data = this.wasteSourceServiceTimes[id][label][source];
						bySource[source].weight += data.weight;
						bySource[source].cost += data.cost;
					});
				});
			});

			bySource = Object.values(bySource).filter((wasteSource) =>
				// don't show waste source when cost/weight is `0` or `null`
				Boolean(this.isCostToggleActive ? wasteSource.cost : wasteSource.weight)
			);

			if (this.isCostToggleActive) return this.$utils.sortDesc(bySource, "cost");

			return this.$utils.sortDesc(bySource, "weight");
		},
		cardTitle,
	},

	methods: { render },

	mounted() {
		this.render();
	},
};

function render() {
	// reset chart data before appending new data
	this.chartData = {
		labels: [],
		datasets: [
			{
				backgroundColor: [],
				data: [],
			},
		],
	};

	let totalWeight = 0,
		totalCost = 0;

	this.sortedWasteSource.forEach((waste) => {
		totalWeight += waste.weight;
		totalCost += waste.cost;
	});

	this.sortedWasteSource.forEach((waste) => {
		const label = this.$t(`toggle_legend.${waste.source}`),
			MAX_PERCENT = 100;

		let percentage = null;

		if (this.isCostToggleActive) percentage = (waste.cost * MAX_PERCENT) / totalCost;
		else percentage = (waste.weight * MAX_PERCENT) / totalWeight;

		this.chartData.datasets[0].data.push(percentage);
		this.chartData.datasets[0].backgroundColor.push(waste.__color);
		this.chartData.datasets[0].borderWidth = 0;
		circleChartOptions.tooltips.backgroundColor.push(waste.__color);

		this.chartData.labels.push(label);
	});

	this.renderChart(this.chartData, circleChartOptions);
}

function cardTitle() {
	switch (this.activeWasteType) {
		case "unavoidable":
			return this.$t("special_cases.sources_of_waste_unavoidable");
		case "avoidable":
			return this.$t("special_cases.sources_of_waste_avoidable");
		case "all":
		default:
			return this.$t("special_cases.sources_of_waste_all");
	}
}
